import { SharedService } from '../../../shared/services/sharedService';
import { ApplicationConstants } from '../../../shared/applicationConstants';
import messages from './password-modal-translations';
import * as $ from 'jquery';

export default {
    name: 'mapViewerPasswordModal',
    data() {
        return {
            submitError: false,
            password: '',
            visorOptions: null,
        };
    },
    i18n: {
        messages,
    },
    props: {
		show: { type: Boolean },
		isAtlasMode: { type: Boolean },
    },
    methods: {
        dismiss: function () {
            $('#password-modal').removeClass('animate-flex-modal');
            this.submitError = false;
        },
        submit: function () {
            const data = {
                clauVisor: this.password,
                businessId:this.visorOptions.businessid                    
            };
            //postCrypto
            SharedService.httpPostCrypto(ApplicationConstants.visorPasswordUrl, data).then((response) => {
                if (response.status === 200 || response.status === 202) {
                    var results = response.body;
                    if(results.status === "ERROR"){
                        this.submitError = true;
                        this.submitSuccess = false;
                    }else{
                        this.submitError = false;
                        this.submitSuccess = true;

                        this.dismiss();
                        this.$emit('loadConfig', results);
                    }
                } else {
                    this.submitError = true;
                    this.submitSuccess = false;
                }
                $('#password-modal #password').val('');
            });
        },
    },
    mounted: function () {
        this.visorOptions = getParamsVisor();
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/password-modal/password-modal.js